<div class="password-requirements-box p-3 mt-3">
  <div class="requirement-title mb-3">{{ 'AUTH.PASSWORD_REQUIREMENTS.TITLE' | translate }}</div>

  <div class="d-flex align-items-center mb-3" [ngClass]="requirements.minLength ? 'requirement-success' : 'text-muted'">
    <mat-icon class="mr-2 icon-16 d-flex align-items-center justify-content-center">{{ requirements.minLength ? 'check' : 'close' }}</mat-icon>
    <span class="requirement-text">{{ 'AUTH.PASSWORD_REQUIREMENTS.MIN_CHARACTERS' | translate }}</span>
  </div>

  <div class="d-flex align-items-center mb-3" [ngClass]="requirements.upperCase ? 'requirement-success' : 'text-muted'">
    <mat-icon class="mr-2 icon-16 d-flex align-items-center justify-content-center">{{ requirements.upperCase ? 'check' : 'close' }}</mat-icon>
    <span class="requirement-text">{{ 'AUTH.PASSWORD_REQUIREMENTS.UPPERCASE_LETTER' | translate }}</span>
  </div>

  <div class="d-flex align-items-center mb-3" [ngClass]="requirements.number ? 'requirement-success' : 'text-muted'">
    <mat-icon class="mr-2 icon-16 d-flex align-items-center justify-content-center">{{ requirements.number ? 'check' : 'close' }}</mat-icon>
    <span class="requirement-text">{{ 'AUTH.PASSWORD_REQUIREMENTS.NUMBER' | translate }}</span>
  </div>

  <div class="d-flex align-items-center mb-2" [ngClass]="requirements.specialChar ? 'requirement-success' : 'text-muted'">
    <mat-icon class="mr-2 icon-16 d-flex align-items-center justify-content-center">{{ requirements.specialChar ? 'check' : 'close' }}</mat-icon>
    <span class="requirement-text">{{ 'AUTH.PASSWORD_REQUIREMENTS.SPECIAL_CHARACTER' | translate }}</span>
  </div>
</div>
